import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PostDetails = ({ isDarkMode }) => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(`https://digitalcontentengine.com/v1/sites/1/posts/slug/${slug}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setPost(data.data);

        // Apply article-specific search and social metadata once the post loads.
        document.title = data.data.meta.seo_title || data.data.title;
        document.querySelector('meta[name="description"]').setAttribute('content', data.data.meta.seo_description || data.data.excerpt);
        document.querySelector('meta[property="og:title"]').setAttribute('content', data.data.meta.seo_title || data.data.title);
        document.querySelector('meta[property="og:description"]').setAttribute('content', data.data.meta.seo_description || data.data.excerpt);
        document.querySelector('meta[name="twitter:title"]').setAttribute('content', data.data.meta.seo_title || data.data.title);
        document.querySelector('meta[name="twitter:description"]').setAttribute('content', data.data.meta.seo_description || data.data.excerpt);
        if (data.data.image_url) {
          document.querySelector('meta[property="og:image"]').setAttribute('content', data.data.image_url);
          document.querySelector('meta[name="twitter:image"]').setAttribute('content', data.data.image_url);
        }

      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();

  }, [slug]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!post) {
    return <div>Post not found</div>;
  }

  return (
    <div className={`container pt-5 ${isDarkMode ? 'text-white' : ''}`}>
      <h1 className="my-4">{post.title}</h1>
      {post.meta.reading_time_minutes && (
        <p className={isDarkMode ? 'text-white-50' : 'text-muted'}>Reading time: {post.meta.reading_time_minutes} minutes</p>
      )}
      {post.meta.tags && post.meta.tags.length > 0 && (
        <div className="mb-3">
          {post.meta.tags.map((tag, index) => (
            <span key={index} className="badge bg-secondary me-2">{tag}</span>
          ))}
        </div>
      )}
      {post.image_url && <img src={post.image_url} alt={post.title} className="img-fluid mb-4" decoding="async" />}
      <div dangerouslySetInnerHTML={{ __html: post.body_html }} />
    </div>
  );
};

export default PostDetails;
